import { postRoute } from "../client"

export const markNotificationsReadRoute = postRoute<{ success: true; unreadCount: number }>("/api/notifications/read")
